/**
 * Generate N-grams from a string with padding for better edge matching
 */
const generateNgrams = (str, n = 3) => {
  if (!str || str.length < n) return [str]

  // Pad string for better edge matching
  const padded = `$$${str}!`
  const ngrams = []

  for (let i = 0; i <= padded.length - n; i += 1) {
    let ngram = padded.slice(i, i + n)

    // Sort characters in ngrams that don't contain padding for transposition tolerance
    if (!ngram.includes('$') && !ngram.includes('!')) {
      ngram = ngram.split('').sort().join('')
    }

    ngrams.push(ngram)
  }

  return ngrams
}

export default generateNgrams
